import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Addresses_ds_find_owner_account_lookupService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { accountId: number, ownerId: number }): 
  Promise<{ result: { OwnerId?: number, AccountId?: number } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.accountId)) {
      $missingRequiredInParams.push('\'accountId\'');
    }
    if (isNil($inParams.ownerId)) {
      $missingRequiredInParams.push('\'ownerId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      accountId: number, ownerId: number    }) {
        if(isNil($inParams.accountId)) {
          return true; 
        }
        if(isNil($inParams.ownerId)) {
          return true; 
        }
      return false;
    }
}
